import Profile from '../components/Auth/Profile'

let routes = {
    path: '/profile',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/profile',
            component: Profile,
            meta: {
              title: "Perfil",
              breadcrumb: `<li><a href="/"><i class="ti-home"></i> Dashboard </a></li><li><a href="/"><i class="ti-user"></i> Profile</a></li>`
            }
        }
    ]        
}


export default routes



// WEBPACK FOOTER //
// ./src/router/profile.js